export default __webpack_public_path__ + "static/media/my-markit-inc.38cc7182.svg";